import { ItiBaseDto } from '@/iti-core-vue';

export class Categories extends ItiBaseDto {
    public id !: number;
    public categoryFirstLevelId !: number; 
    public categoryFirstLevelCode !: string; 
    public categoryFirstLevelDescription !: string; 
    public categorySecondLevelId !: number; 
    public categorySecondLevelCode !: string; 
    public categorySecondLevelDescription !: string;
    public categoryThirdLevelId !: number; 
    public categoryThirdLevelCode !: string;
    public categoryThirdLevelDescription !: string;
    public categoryFourthLevelId !: number; 
    public categoryFourthLevelCode !: string; 
    public categoryFourthLevelDescription !: string; 
}